// extracted by mini-css-extract-plugin
module.exports = {"container":"LessonRangeInput_container__1MOdf"};